const ALLOWED = /[\d+\s\-()]/

function filter(value: string): string {
  return value.split('').filter(c => ALLOWED.test(c)).join('')
}

export function usePhoneInputValidation() {
  const handleKeydown = (e: KeyboardEvent) => {
    const key = e.key
    if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(key)) return
    if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x', 'z'].includes(key.toLowerCase())) return
    if (!ALLOWED.test(key)) e.preventDefault()
  }

  const createInputHandler = (emit: (value: string) => void) => (e: Event) => {
    const el = e.target as HTMLInputElement
    const value = filter(el.value)
    el.value = value
    emit(value)
  }

  return { handleKeydown, createInputHandler }
}